import { useMutation } from '@apollo/client';
import { ResetPasswordInput } from '../../shared/types';
import { CreateResetPasswordResponse, CreateResetPasswordRequest, CITRIN_RESET_PASSWORD } from '..';

type CreateMutationFunction = (request: ResetPasswordInput) => Promise<String>;
export const useResetPasswordMutation = (): { mutation: CreateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<CreateResetPasswordResponse, CreateResetPasswordRequest>(
        CITRIN_RESET_PASSWORD
    );
    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_resetPassword;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
